import { isNull } from 'lodash/fp';

import { ApplicationState } from '../../../../store/types';
import { CalculatorFieldTypeDB, CalculatorFieldTypeUI, CalculatorManagerPage, CalculatorPadOptionDB, CalculatorPadOptionUI, CalculatorPromptDB, CalculatorPromptUI } from './types';
import { getCalculatorRoot } from '../../store/selectors';

export const getCalculatorManagerPage = (state: ApplicationState): CalculatorManagerPage => getCalculatorRoot(state).calculatorManagerPage;

export const getAllPadOptions = (state: ApplicationState): CalculatorPadOptionDB[] => getCalculatorRoot(state).padOptions;

export const getAllCalculatorFields = (state: ApplicationState): CalculatorFieldTypeDB[] => getCalculatorRoot(state).calculatorFields;

export const getAllCalculatorFieldNames = (state: ApplicationState): { name: string; calculatorFieldTypeId: number; }[] => getAllCalculatorFields(state).map(({ name, calculatorFieldTypeId }) => ({ name, calculatorFieldTypeId }));

export const getCalculatorFieldType = (fieldType: string) => (state: ApplicationState): CalculatorFieldTypeDB => {
    const allCalculatorFieldTypes = getAllCalculatorFields(state);
    const selectedCalculatorField = allCalculatorFieldTypes.find(({ name }) => name === fieldType)!;
    return selectedCalculatorField;
};

export const getCalculatorFieldTypeOrNull = (fieldType: string | null) => (state: ApplicationState): CalculatorFieldTypeDB | null => {
    if (isNull(fieldType)) {
        return null;
    }
    const allCalculatorFieldTypes = getAllCalculatorFields(state);
    const selectedCalculatorField = allCalculatorFieldTypes.find(({ name }) => name === fieldType)!;
    return selectedCalculatorField;
};

// Manager
export const getPadOptionsModalOpen = (state: ApplicationState): boolean => getCalculatorRoot(state).padOptionsModalOpen;

export const getCurrentPadOption = (state: ApplicationState): CalculatorPadOptionUI | null => getCalculatorRoot(state).currentPadOption;

export const getSavedPadOption = (state: ApplicationState): CalculatorPadOptionUI | null => getCalculatorRoot(state).savedPadOption;

export const getPadOptionHasUpdated = (state: ApplicationState): boolean => getCalculatorRoot(state).padOptionHasUpdated;

export const getCurrentCalculatorFieldType = (state: ApplicationState): CalculatorFieldTypeUI | null => getCalculatorRoot(state).currentCalculatorField;

export const getSavedCalculatorFieldType = (state: ApplicationState): CalculatorFieldTypeUI | null => getCalculatorRoot(state).savedCalculatorField;

export const getCalculatorFieldTypeHasUpdated = (state: ApplicationState): boolean => getCalculatorRoot(state).calculatorFieldHasUpdated;

export const getShowCalculatorFieldTypePreview = (state: ApplicationState): boolean => getCalculatorRoot(state).showCalculatorPreview;

// Calculator Prompt
export const getIsFetchingCalculatorPrompts = (state: ApplicationState): boolean => getCalculatorRoot(state).isFetchingCalculatorPrompts;

export const getIsSavingCalculatorPrompt = (state: ApplicationState): boolean => getCalculatorRoot(state).isSavingCalculatorPrompt;

export const getIsDeletingCalculatorPrompts = (state: ApplicationState): boolean => getCalculatorRoot(state).isDeletingCalculatorPrompt;

export const getAllCalculatorPrompts = (state: ApplicationState): CalculatorPromptDB[] => getCalculatorRoot(state).calculatorPrompts;

export const getSelectedCalculatorPrompt = (state: ApplicationState): CalculatorPromptUI | null => getCalculatorRoot(state).selectedCalculatorPrompt;

export const getCalculatorPromptToDelete = (state: ApplicationState): CalculatorPromptDB | null => getCalculatorRoot(state).calculatorPromptToDelete;

export const getCalculatorPromptUpdated = (state: ApplicationState): boolean => getCalculatorRoot(state).selectedPromptUpdated;

export const getCurrentCalculatorPromptOrderForType = (state: ApplicationState): CalculatorPromptDB[] => getCalculatorRoot(state).currentSelectedFieldTypePromptOrder;

export const getSavedCalculatorPromptOrderForType = (state: ApplicationState): CalculatorPromptDB[] => getCalculatorRoot(state).savedSelectedFieldTypePromptOrder;
